import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const FOUNDERS = [
  {
    name: "Gaetano Iodice",
    initials: "GI",
    email: "gaetano.iodice@gmail.com",
    phone: "+39 339 325 4073",
    phone_href: "tel:+393393254073",
  },
  {
    name: "Mariano Iodice",
    initials: "MI",
    email: "Iogamasrls@gmail.com",
    phone: "+39 338 571 4281",
    phone_href: "tel:+393385714281",
  },
];

export default function Leadership() {
  return (
    <section id="leadership" className="border-t border-black/10 bg-paper" data-testid="leadership-section">
      <div className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-16 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between"
        >
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-terracotta">Leadership</p>
            <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tighter text-ink sm:text-5xl lg:text-6xl">
              I visionari di iogama
            </h2>
          </div>
          <p className="max-w-md font-display text-xl font-bold tracking-tight text-ink sm:text-2xl">
            Due fratelli, una sola ossessione.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {FOUNDERS.map((f, i) => (
            <motion.article
              key={f.name}
              initial={{ opacity: 0, y: 48 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: EASE, delay: i * 0.15 }}
              className="group relative overflow-hidden border border-black/10 bg-white p-8 transition-colors duration-500 hover:bg-ink lg:p-12"
              data-testid={`founder-card-${f.name.split(" ")[0].toLowerCase()}`}
            >
              <span
                className="pointer-events-none absolute -bottom-10 -right-4 select-none font-display text-[11rem] font-extrabold leading-none tracking-tighter text-ink/[0.04] transition-colors duration-500 group-hover:text-white/[0.06] lg:text-[15rem]"
                aria-hidden="true"
              >
                {f.initials}
              </span>
              <div className="relative">
                <h3 className="font-display text-4xl font-extrabold tracking-tighter text-ink transition-colors duration-500 group-hover:text-white lg:text-5xl">
                  {f.name}
                </h3>
                <div className="mt-10 flex flex-col gap-2 border-t border-black/10 pt-6 transition-colors duration-500 group-hover:border-white/15 sm:flex-row sm:items-center sm:justify-between">
                  <a
                    href={f.phone_href}
                    className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink/60 transition-colors duration-300 hover:text-cobalt group-hover:text-white/70"
                    data-testid={`founder-phone-${f.name.split(" ")[0].toLowerCase()}`}
                  >
                    {f.phone}
                  </a>
                  <a
                    href={`mailto:${f.email}`}
                    className="inline-flex items-center gap-2 break-all font-mono text-[11px] uppercase tracking-[0.14em] text-ink underline-offset-4 transition-colors duration-300 hover:text-cobalt hover:underline group-hover:text-white"
                    data-testid={`founder-contact-${f.name.split(" ")[0].toLowerCase()}`}
                  >
                    {f.email}
                    <ArrowUpRight className="h-3.5 w-3.5 shrink-0" />
                  </a>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
